import { createEntityAdapter } from '@reduxjs/toolkit'
import { IAttribute } from '../../types'

export const attributesAdapter = createEntityAdapter<IAttribute>()